import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {CieloService} from 'src/app/services/cielo.service';
import {CollectService} from 'src/app/services/collect.service';

import {DomSanitizer} from '@angular/platform-browser';
import {Collect} from 'src/app/models/collect';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

@Component({
  selector: 'app-member-collect-back',
  templateUrl: './member-collect-back.component.html',
  styleUrls: [ './member-collect-back.component.scss' ]
})

export class MemberCollectBackComponent implements OnInit {

  public current: Collect;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'product_name' ];

  public qrcodeImage: any = null;
  public qrcodeString: any;

  public link: any;
  public paymentId: any;
  public returnCode: any;
  public status: any;
  public ReceivedDate: any = {};

  public collect_id: string = ''

  public waiting: any;


  constructor (
    private route: ActivatedRoute,
    private _collectService: CollectService,
    private _cieloService: CieloService,
    private _spinnerService: SpinnerService,
    private snackBar: SnackBarIconService,
    private sanitizer: DomSanitizer
  ) {
    this.collect_id = this.route.snapshot.paramMap.get('collect_id');
    if (this.collect_id) {
      this.getCollect(this.collect_id)
    }

  }

  ngOnInit () { }


  getCollect (collect_id) {
    this._collectService.getById(collect_id)
      .subscribe((result) => {
        this.current = this._collectService.createCollect(collect_id, result.payload.data())
        if(result.payload.data().pix.ReceivedDate){
          this.ReceivedDate = this.formatReceivedDate(result.payload.data().pix.ReceivedDate)
        }
        //
        this.collect_id = this.current.id
        console.log('this.current.collect.id: ' + JSON.stringify(this.collect_id))
        this.dataSource = new MatTableDataSource(this.current.collect);
        //
        switch (this.current.status) {
          case '0':
            console.log("email enviado");
            this.updateStatus("1");
            break;
          case '1':
            console.log("email visualizado");
            break;
          case '2':
            console.log("pix criado");
            this.renderizePix(this.current.pix.QrCodeBase64Image, this.current.pix.QrCodeString)
            break;
          case '3':
            console.log("pix pago");
            break;
        }

      })
  }

  formatReceivedDate (date: string) {
    let parts = date.split(' ')
    let year = parts[0].substring(0,4)
    let month = parts[0].substring(5, 7)
    let day = parts[0].substring(8,10)

    let time = parts[1].split(':')

    return {
      'time': time[0] + ':' + time[1],
      'day': day + '/' + month + '/' + year
    }

  }

  createPIX () {

    this.waiting = this._spinnerService.show()

    const cardAuthorize: any = {
      "MerchantOrderId": this.collect_id,
      "Customer": {
        "Name": this.current.member_name,
        "Identity": this.current.member_cpf,
        "IdentityType": "CPF"
      },
      "Payment":
      {
        "Type": "Pix",
        "Amount": this.current.value * 100 // in cents
      }
    }

    console.log('cardAuthorize: ' + JSON.stringify(cardAuthorize))

    this._cieloService.callCieloPIX(cardAuthorize)
      .then((ret: any) => {

        const status = ret.data[ 0 ].status;
        const result = ret.data[ 0 ].body

        //console.log('result: ' + JSON.stringify(result))
        console.log('status: ' + status)
        console.log('-----------------------------------------')

        if (result.Payment) {

          if (result.Payment.QrCodeBase64Image) {
            this.renderizePix(result.Payment.QrCodeBase64Image, result.Payment.QrCodeString)
          }

          this.current.pix = {...result.Payment}
          console.log('this.current.pix: ' + JSON.stringify(this.current.pix))

          this.current.status = "2";
          this.updateCollect(this.current)

        }

      })
      .catch((error) => {
        console.log("erro:: " + error.message)
      })
  }

  renderizePix (qrcodeImage, qrcodeString) {
    let imgSource = qrcodeImage
    this.qrcodeImage = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${ imgSource }`);
    this.qrcodeString = qrcodeString;
  }

  updateCollect (entity) {
    this._collectService.update(entity.id, entity)
      .then((result) => {
        console.log('updated')
        this.waiting.close()
      })
      .catch((err) => {
        console.log('erro: ' + err.message)
      })
  }

  async copyToClipboard (data) {
    await navigator.clipboard.writeText(data);
    this.snackBar.openSnackBar("Copiado", '', 'success')
  }

  updateStatus (status) {
    this._collectService.updateStatus(this.collect_id, status)
      .then(() => {
        console.log("status atualizado: " + this.collect_id + ": " + status)
      })
      .catch((err) => {
        console.log("erro ao visualizar")
      })

  }

}
